module.exports = __webpack_public_path__ + "img/SSB_House_Salad.ccda9a8a.jpg";